import Overview from "../../../../src/docs/main-overview";
import * as React from 'react';
export default {
  Overview,
  React
};